import { render, staticRenderFns } from "./BigScreenForWXCW1.vue?vue&type=template&id=7c1d0ef4&scoped=true&"
import script from "./BigScreenForWXCW1.vue?vue&type=script&lang=js&"
export * from "./BigScreenForWXCW1.vue?vue&type=script&lang=js&"
import style0 from "./BigScreenForWXCW1.vue?vue&type=style&index=0&id=7c1d0ef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1d0ef4",
  null
  
)

export default component.exports